import "./App.css";
import "./index.css";
import Routes1 from "./Routes1";
import Header from "./Components/Header/Header";

//window.API_PREFIX = "https://asf-backend.azurewebsites.net/";
// window.API_PREFIX="https://asfbackendv6env.eba-m67qpmqq.us-west-2.elasticbeanstalk.com/";
// window.API_PREFIX = "http://127.0.0.1:8000/";
window.API_PREFIX = "https://asf-application.in/";

window.s3REGION = "us-west-2";
window.s3BUCKET = "asfdocumentstorage";

function App() {
  return (
    <>
      <Header />
      <Routes1 />
    </>
  );
}

export default App;
